import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { Field } from '@tsim/model';

export class ArticleEntity extends BaseRootEntity {
  @Field(String, true)
  title!: string;

  @Field(String, true)
  category!: string;

  @Field(String, true)
  url!: string;

  @Field(Number, true)
  position = 1;

  @Field(String, true)
  content!: string;
}
